module.exports = __webpack_public_path__ + "media/images/livivska-2b00bd57aaa95c638c81898681162694.svg";